import { FeaturesInfoDrawer as View } from "ui-components";

import { useCloseMapTool } from "~map-view/states";

const MOCK_FEATURES = [
	{
		id: "feature-1",
		name: "Clark",
		state: "Nevada",
		title: "Clark County, Nevada",
		school: 4,
	},
	{
		id: "feature-2",
		name: "Humboldt",
		state: "Nevada",
		title: "Humboldt County, Nevada",
		school: 7,
	},
];

export const FeaturesInfoDrawer = () => {
	const closeMapTool = useCloseMapTool();
	return (
		<View
			onClose={closeMapTool}
			features={MOCK_FEATURES}
		/>
	);
};
